export const MAX_METADATA_KEYS = 200;

export const DEFAULT_GLOBAL_TABLE_RESULT_LIMIT = 20;

export const DEFAULT_GLOBAL_TABLE_MAX_RESULT_LIMIT = 1000;
export const MORE_THAN_MAX_RESULT_LIMIT = `1K+`;

// @deprecated use the constant from the core lib
export const NIL_FILTER_VALUE = 'DATA_EXPLORATION_NO_VALUE_PLACEHOLDER';
// @deprecated use the constant from the core lib
export const NIL_FILTER_LABEL = 'N/A';

export const METADATA_KEY_SEPARATOR = '-';
export const MAX_RESULT_LIMIT_ASSET = 1000;
export const MAX_RESULT_LIMIT_DATAPOINTS = 100;
export const MAX_DOWNLOAD_LIMIT_DATAPOINTS = 100000;

export const DEFAULT_SCORE_SORTING = [
  {
    property: ['_score_'],
  },
];
export const MAX_SEQUENTIAL_REQUEST_LIMIT_3D = 10;

export const VALID_IMAGE_TYPES = ['png', 'jpg', 'jpeg', 'tiff', 'gif'];

export const POINT_CLOUD_FORMAT = 'ept-pointcloud';
